import { Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
export default function HelpCenterButton() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Button, {
    className: classes.helpCenterButton,
    onClick: () => window.open('https://pro.livable.com/knowledge', '_blank'),
    variant: "actionButton",
    'custom-attribute': '335-HelpCenterButton'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "question"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.more_details_at_help_center')));
}